import {Component, ContentChild, OnInit, TemplateRef} from '@angular/core';
import {NgTemplateOutlet} from '@angular/common';
import {TranslateModule} from '@ngx-translate/core';

@Component({
    selector: 'app-sidenav',
    templateUrl: './sidenav.component.html',
    styleUrls: ['./sidenav.component.scss'],
    imports: [NgTemplateOutlet, TranslateModule]
})
export class SidenavComponent implements OnInit {

  @ContentChild('sidenavContent') sidenavContent: TemplateRef<any>;
  @ContentChild('mainContent') mainContent: TemplateRef<any>;

  constructor() { }

  ngOnInit() {
  }

}
